module.exports = __webpack_public_path__ + "img/quizzz-5.b8c1dafd.jpg";